export class RestoreGoogleWorkspaceGroupByEntityRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<GoogleWorkspaceGroupRestoreWorkload>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceGroupByEntityRequest.attributeTypeMap;
    }
    constructor() {
    }
}
